"use strict";

exports.__esModule = true;
exports.Transfers = void 0;
var _sdkCore = require("@acala-network/sdk-core");
var _graphqlRequest = require("graphql-request");
var _baseHistoryFetcher = require("../base-history-fetcher");
var _resolveLinks = require("../utils/resolve-links");
var _truncateAddress = require("../utils/truncate-address");
var _getChainType = require("../../utils/get-chain-type");
class Transfers extends _baseHistoryFetcher.BaseHistoryFetcher {
  constructor(configs) {
    super(configs);
  }
  async fetch(params) {
    const variables = {
      account: params.address
    };
    if (params.token) {
      variables.token = (0, _sdkCore.forceToCurrencyName)(params.token);
    }
    const paramsSchema = `$account: String ${params.token ? ',$token: String' : ''}`;
    const filterSchema = `
      filter: {
        isSystemCall: { equalTo: false }
        ${params.token ? 'tokenId: { equalTo: $token } ' : ''}
        or: [{ fromId: { equalTo: $account } }, { toId: { equalTo: $account } }]
      }
    `;
    const resultShema = `
      nodes {
        id
        fromId
        toId
        tokenId
        blockNumber
        amount
        extrinsic
        timestamp
      }
    `;
    const result = await (0, _graphqlRequest.request)(this.configs.endpoint, (0, _graphqlRequest.gql)`
        query (${paramsSchema}) {
          transfers(
            ${filterSchema}
            first: 20
            orderBy: TIMESTAMP_DESC
          ) {
            ${resultShema}
          }
        }
      `, variables);
    return this.transform(result);
  }
  transform(data) {
    var _data$transfers, _data$transfers$nodes;
    if (data !== null && data !== void 0 && (_data$transfers = data.transfers) !== null && _data$transfers !== void 0 && (_data$transfers$nodes = _data$transfers.nodes) !== null && _data$transfers$nodes !== void 0 && _data$transfers$nodes.length) {
      return data.transfers.nodes.map(item => {
        return {
          data: {
            from: item.fromId,
            to: item.toId,
            amount: item.amount,
            token: item.tokenId,
            timestamp: item.timestamp
          },
          message: this.createMessage(item.fromId, item.toId, item.tokenId, item.amount),
          resolveLinks: (0, _resolveLinks.resolveLinks)((0, _getChainType.getChainType)(this.configs.wallet.consts.runtimeChain), item.extrinsic, item.blockNumber),
          method: 'balances.Transfer',
          extrinsicHash: item.extrinsic,
          blockNumber: item.blockNumber
        };
      });
    }
    return [];
  }
  createMessage(from, to, tokenName, balance) {
    var _this$fetchParams;
    const current = (_this$fetchParams = this.fetchParams) === null || _this$fetchParams === void 0 ? void 0 : _this$fetchParams.address;
    const token = this.configs.wallet.getToken(tokenName);
    const amount = _sdkCore.FixedPointNumber.fromInner(balance, token === null || token === void 0 ? void 0 : token.decimals).toNumber(6);
    let action = '';
    if (from === current) {
      action = `Send ${amount} ${token === null || token === void 0 ? void 0 : token.display} to ${(0, _truncateAddress.truncateAddress)(to)}`;
    }
    if (to === current) {
      action = `Receive ${amount} ${token === null || token === void 0 ? void 0 : token.display} from ${(0, _truncateAddress.truncateAddress)(from)}`;
    }
    return action;
  }
}
exports.Transfers = Transfers;